import PropTypes from "prop-types";

const { arrayOf, number, shape, string } = PropTypes;

export const GmomadGenomesType = arrayOf(
  shape({
    ac: number,
    ac_afr: number,
    ac_afr_female: number,
    ac_afr_male: number,
    ac_amr: number,
    ac_amr_female: number,
    ac_amr_male: number,
    ac_asj: number,
    ac_asj_female: number,
    ac_asj_male: number,
    ac_eas: number,
    ac_eas_female: number,
    ac_eas_male: number,
    ac_female: number,
    ac_fin: number,
    ac_fin_female: number,
    ac_fin_male: number,
    ac_male: number,
    ac_nfe: number,
    ac_nfe_est: number,
    ac_nfe_female: number,
    ac_nfe_male: number,
    ac_nfe_nwe: number,
    ac_nfe_onf: number,
    ac_nfe_seu: number,
    ac_oth: number,
    ac_oth_female: number,
    ac_oth_male: number,
    af: number,
    age_hist_het_30_35: number,
    age_hist_het_35_40: number,
    age_hist_het_40_45: number,
    age_hist_het_45_50: number,
    age_hist_het_50_55: number,
    age_hist_het_55_60: number,
    age_hist_het_60_65: number,
    age_hist_het_65_70: number,
    age_hist_het_70_75: number,
    age_hist_het_75_80: number,
    age_hist_het_over_80: number,
    age_hist_het_under_30: number,
    age_hist_hom_30_35: number,
    age_hist_hom_35_40: number,
    age_hist_hom_40_45: number,
    age_hist_hom_45_50: number,
    age_hist_hom_50_55: number,
    age_hist_hom_55_60: number,
    age_hist_hom_60_65: number,
    age_hist_hom_65_70: number,
    age_hist_hom_70_75: number,
    age_hist_hom_75_80: number,
    age_hist_hom_over_80: number,
    age_hist_hom_under_30: number,
    an: number,
    an_afr: number,
    an_afr_female: number,
    an_afr_male: number,
    an_amr: number,
    an_amr_female: number,
    an_amr_male: number,
    an_asj: number,
    an_asj_female: number,
    an_asj_male: number,
    an_eas: number,
    an_eas_female: number,
    an_eas_male: number,
    an_female: number,
    an_fin: number,
    an_fin_female: number,
    an_fin_male: number,
    an_male: number,
    an_nfe: number,
    an_nfe_est: number,
    an_nfe_female: number,
    an_nfe_male: number,
    an_nfe_nwe: number,
    an_nfe_onf: number,
    an_nfe_seu: number,
    an_oth: number,
    an_oth_female: number,
    an_oth_male: number,
    filter: string,
    main_data: string,
    nhomalt: number,
    nhomalt_afr: number,
    nhomalt_afr_female: number,
    nhomalt_afr_male: number,
    nhomalt_amr: number,
    nhomalt_amr_female: number,
    nhomalt_amr_male: number,
    nhomalt_asj: number,
    nhomalt_asj_female: number,
    nhomalt_asj_male: number,
    nhomalt_eas: number,
    nhomalt_eas_female: number,
    nhomalt_eas_male: number,
    nhomalt_female: number,
    nhomalt_fin: number,
    nhomalt_fin_female: number,
    nhomalt_fin_male: number,
    nhomalt_male: number,
    nhomalt_nfe: number,
    nhomalt_nfe_est: number,
    nhomalt_nfe_female: number,
    nhomalt_nfe_male: number,
    nhomalt_nfe_nwe: number,
    nhomalt_nfe_onf: number,
    nhomalt_nfe_seu: number,
    nhomalt_oth: number,
    nhomalt_oth_female: number,
    nhomalt_oth_male: number,
    original_variant: string,
    version: string,
  })
);
